import axiosInstance from "../../../../axiosInstance";
import { error, info, success, warning } from "../../../../store/notification/actions";

export const getAssets = (storeId) => {
  info("Loading Assets...");
  return axiosInstance
    .get(`/asset/getAssets/${storeId}`)
    .then((response) => {
      if (response.data.status === "success") {
        if (response.data.data.length > 0) {
          success("Loaded Successfully!!!");
        } else {
          warning("No records found !!!");
        }
        return { message: "", hasError: false, data: response.data.data };
      } else {
        const errorMessage = response.data.error[0].message;
        error(errorMessage);
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response.data.error[0].message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const addAsset = (asset) => {
  info("Adding new Asset...");
  const {
    assetid,
    assetname,
    quantity,
    vendor,
    orderno,
    purchasedate,
    expirydate,
    storeid,
  } = asset;
  return axiosInstance
    .post("/asset/addAsset", {
      assetid,
      assetname,
      quantity,
      vendor,
      orderno,
      purchasedate,
      expirydate,
      storeid,
    })
    .then((response) => {
      if (response.data.status === "success") {
        success("Asset added successfully!");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        const errorMessage = response.data.error[0].message;
        error(errorMessage);
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response.data.error[0].message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const editAsset = (asset) => {
  const {
    assetid,
    assetname,
    quantity,
    vendor,
    orderno,
    purchasedate,
    expirydate,
    storeid,
  } = asset;
  info("Editing Asset...");
  return axiosInstance
    .post("/asset/editAsset", {
      assetid,
      assetname,
      quantity,
      vendor,
      orderno,
      purchasedate,
      expirydate,
      storeid,
    })
    .then((response) => {
      if (response.data.status === "success") {
        success("Asset edited successfully!");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        const errorMessage = response.data.error[0].message;
        error(errorMessage);
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response.data.error[0].message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const deleteAsset = (asset) => {
  info("Deleting Asset...");
  return axiosInstance
    .post("/asset/deleteAsset", asset)
    .then((response) => {
      if (response.data.status === "success") {
        success("Asset deleted successfully!");
        return { message: "", hasError: false, data: response.data.data };
      } else {
        const errorMessage = response.data.error[0].message;
        error(errorMessage);
        return {
          message: errorMessage,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response.data.error[0].message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};
